import { render, staticRenderFns } from "./OrderDel.vue?vue&type=template&id=7cc1b20a&scoped=true&"
import script from "./OrderDel.vue?vue&type=script&lang=js&"
export * from "./OrderDel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc1b20a",
  null
  
)

export default component.exports